export const axios = require('axios').default
const axiosRetry = require('axios-retry');
export const API = process.env.VUE_APP_ORIGIN === 'true' ? 'https://api.altezza.travel' : 'https://dev-api.altezza.travel'

let currentRefreshRequest = null

const storedAuth = getAuthData()
if (storedAuth) {
    axios.defaults.headers.common.Authorization = 'Bearer ' + storedAuth.access_token
}

axios.interceptors.request.use(
    async config => {
        if (config.url.toString().includes('/login')
            || config.url.toString().includes('/refresh')
            || config.url.toString().includes('/logout')
            || config.url.toString().includes('settings/clients/descriptions')) {
            delete axios.defaults.headers.common.Authorization
            return {
                ...config,
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        }

        return config
    },
    error => Promise.reject(error)
)

axios.interceptors.response.use(
    response => {
        const url = response.config.url.toString()
        if (url.includes('/login') || url.includes('/refresh')) {
            axios.defaults.headers.common.Authorization = 'Bearer ' + response.data.access_token
            setAuthData(response.data)
        }
        return response
    },
    async error => {
        if (error.response.status === 401) {
            const errData = error.response.data
            if (errData && errData.code === 'REFRESH_TOKEN_NOT_FOUND' || errData.code === 'REFRESH_TOKEN_EXPIRED') {
                window.location = '/marsel'
                deleteUserRoles()
                currentRefreshRequest = null
                return Promise.reject(error)
            }

            const auth = getAuthData()
            if (currentRefreshRequest === null) {
                currentRefreshRequest = refresh('', auth.refresh_token)
            }

            const response = await currentRefreshRequest.then(res => res)
            currentRefreshRequest = null

            axios.defaults.headers.common.Authorization = 'Bearer ' + response.access_token;
            setAuthData(response)
            return await axios({
                ...error.response.config,
                headers: {
                    ...error.response.config.headers,
                    Authorization: 'Bearer ' + response.access_token
                }
            }).then(res => res)
        }
        return Promise.reject(error)
    }
)

export async function setAuthData(token) {
    localStorage.setItem('auth', JSON.stringify(token))
}

function getAuthData() {
    const auth = localStorage.getItem('auth')
    let data
    if (auth) {
        data = JSON.parse(auth)
    }
    return data
}

export function setUserRoles(roles) {
    localStorage.setItem('roles', roles)
}

export function getUserRoles() {
    return localStorage.getItem('roles')
}

export function deleteUserRoles() {
    localStorage.setItem('roles', '')
    localStorage.setItem('auth', '')
}

export async function auth(login, password, mfaCode) {
    return await axios({
        url: `${API}/auth/login`,
        method: 'post',
        data: JSON.stringify({login, password, mfaCode}),
        headers: {
            'Content-Type': 'application/json',
        },

    })
        .then(res => res.data)
}

export async function checkAuthToken() {
    // let time = localStorage.getItem('expires')
    let auth = JSON.parse(localStorage.getItem('auth'))
    if (!auth) {
        return new Error()
    }
    // if(time){
    //     time = +time
    // }
    // if(time < +new Date().getTime()){
    //     console.log('refresh')
    //     // console.log(auth.refresh_token)
    //     let res = await refresh('', auth.refresh_token)
    //     .then(result => {
    //         setAuthData(JSON.stringify(result))
    //         localStorage.setItem('expires', +new Date().getTime() + (+result.expires_in * 1000))
    //         axios.defaults.headers.common.Authorization = 'Bearer ' + result.access_token
    //         return result;
    //     })
    //     console.log(res)
    // }
    return auth
}

export async function logout(token) {
    return await axios({
        url: `${API}/auth/logout?refreshToken=${token}`,
        method: 'post',
    })
        .then(res => res.data)
}

export async function refresh(token, refresh) {
    return await axios({
        url: `${API}/auth/refresh?refreshToken=${refresh}`,
        method: 'post',
        // headers: {
        // 'Authorization' : 'Bearer ' + token,
        // }
    })
        .then(res => res.data)
}

export async function reset(email) {
    return await axios({
        url: `${API}/auth/refresh?`,
        method: 'post',
    })
        .then(res => res.data)
}


export async function getUsers(token) {
    return await axios({
        url: `${API}/users/all`,
        method: 'get',
        headers: {
            // 'Authorization' : 'Bearer ' + token
        }
    })
        .then(res => res.data)
}


export async function getMe(id) {
    // let decode = jwt_decode(token)
    return await axios({
        url: `${API}/users?id=${id}`,
        method: 'get',
    })
        .then(res => res.data)
        .catch(() => 'error')
}

export async function getUser(token, id) {
    return await axios({
        url: `${API}/users?id=${id}`,
        method: 'get',
        headers: {
            // 'Authorization' : 'Bearer ' + token
        }
    })
        .then(res => res.data)
        .catch(() => 'error')
}

export async function deleteUser(token, id) {
    return await axios({
        url: `${API}/users?id=${id}`,
        method: 'delete',
        headers: {
            // 'Authorization' : 'Bearer ' + token
        }
    })
        .then(res => res.data)
}

export async function updateUser(token, user) {
    let rolesTemp = []
    if (user.roles.sales) {
        rolesTemp.push('SALES')
    }
    if (user.roles.content) {
        rolesTemp.push('CONTENT')
    }
    if (user.roles.admin) {
        rolesTemp.push('ADMIN')
    }
    if (user.roles.accountant) {
        rolesTemp.push('ACCOUNTANT')
    }
    return await axios({
        url: `${API}/users`,
        method: 'put',
        headers: {
            // 'Authorization' : 'Bearer ' + token,
            'Content-Type': 'application/json'
        },
        data: JSON.stringify({
            id: user.id,
            login: user.login,
            email: user.email,
            firstName: user.name,
            lastName: user.surname,
            password: user.password || null,
            photo: user.photo,
            signPhoto: user.signPhoto,
            roles: rolesTemp,
            contacts: {
                "TELEGRAM": user.telegram.active ? user.telegram.login : '',
                "TELEGRAM_ID": user.telegram.active ? user.telegram.ID : '',
                "PHONE": user.number || '',
                "WHATSAPP": user.whatsapp.active ? user.number : ''
            },
            countryCode: user.country.code
        })
    })
        .then(res => res.data)
}

export async function createUser(token, user) {
    let rolesTemp = []
    if (user.roles.sales) {
        rolesTemp.push('SALES')
    }
    if (user.roles.content) {
        rolesTemp.push('CONTENT')
    }
    if (user.roles.admin) {
        rolesTemp.push('ADMIN')
    }
    if (user.roles.accountant) {
        rolesTemp.push('ACCOUNTANT')
    }
    return await axios({
        url: `${API}/users`,
        method: 'post',
        headers: {
            // 'Authorization' : 'Bearer ' + token,
            'Content-Type': 'application/json'
        },
        data: JSON.stringify({
            id: user.id,
            login: user.login,
            email: user.email,
            firstName: user.name,
            lastName: user.surname,
            password: user.password || null,
            photo: user.photo,
            signPhoto: user.signPhoto,
            roles: rolesTemp,
            contacts: {
                "TELEGRAM": user.telegram.active ? user.telegram.login : '',
                "PHONE": user.number || '',
                "WHATSAPP": user.whatsapp.active ? user.number : ''
            },
            countryCode: user.country.code
        })
    })
        .then(res => res.data)
}

export async function uploadUserImageWithCrop(formdata) {
    return await axios({
        method: 'post',
        url: `${API}/documents/images/uploads`,
        data: formdata,
    })
        .then(res => res.data)
}

export async function uploadUserImage(token, file) {
    let formdata = new FormData();
    formdata.append("file", file, file.name);
    return await axios({
        method: 'post',
        url: `${API}/documents/images/uploads`,
        data: formdata,
    })
        .then(res => res.data)
}

export async function getFlight(token, id) {
    return await axios({
        url: `${API}/settings/flights?id=${id}`,
        method: 'get',
        headers: {
            // 'Authorization' : 'Bearer ' + token
        }
    })
        .then(res => res.data)
}

export async function getFlights(token, id) {
    return await axios({
        url: `${API}/settings/flights/all?seasonId=${id}`,
        method: 'get',
        headers: {
            // 'Authorization' : 'Bearer ' + token
        }
    })
        .then(res => res.data)
}

// export async function getFlightsList () {
//     return await axios({
//         url: `${API}/settings/flights/list`,
//         method: 'get',
//     })
//     .then(res => res.data)
// }

export function getFlightsAll(startDate) {
    return axios.get(`${API}/settings/flights/all?startDate=${startDate}`)
}

export function getFlightsFind(params) {
    return axios.get(`${API}/settings/flights/find?startDate=${params.startDate}&from=${params.from}&to=${params.to}`)
}

export async function createFlight(token, data) {
    return await axios({
        url: `${API}/settings/flights`,
        method: 'post',
        headers: {
            // 'Authorization' : 'Bearer ' + token,
            'Content-Type': 'application/json'
        },
        data: JSON.stringify(data)
    })
        .then(res => res.data)
}

export async function deleteFlights(token, ids) {
    return await axios({
        url: `${API}/settings/flights?ids=${ids.join('&ids=')}`,
        method: 'delete',
        headers: {
            // 'Authorization' : 'Bearer ' + token
        }
    })
        .then(res => res.data)
}

export async function updateFlights(token, ids, data) {
    return await axios({
        url: `${API}/settings/flights/multi`,
        method: 'put',
        headers: {
            // 'Authorization' : 'Bearer ' + token,
            'Content-Type': 'application/json'
        },
        data: JSON.stringify({
            ...data,
            ids: ids
        })
    })
        .then(res => res.data)
}

export async function updateFlightsCosts(token, data, id) {
    return await axios({
        url: `${API}/settings/flights/costs`,
        method: 'post',
        headers: {
            // 'Authorization' : 'Bearer ' + token,
            'Content-Type': 'application/json'
        },
        data: JSON.stringify({
            seasonId: id,
            costs: data
        })
    })
        .then(res => res.data)
}

export async function getPricesAll() {
    return await axios({
        url: `${API}/settings/transfer/prices/all`,
        method: 'get',
    })
        .then(res => res.data)
}

export async function getPrice(token, id) {
    return await axios({
        url: `${API}/settings/transfer/prices?id=${id}`,
        method: 'get',
        headers: {
            // 'Authorization' : 'Bearer ' + token
        }
    })
        .then(res => res.data)
}


export async function deletePrice(token, id) {
    return await axios({
        url: `${API}/settings/transfer/prices?id=${id}`,
        method: 'delete',
        headers: {
            // 'Authorization' : 'Bearer ' + token
        }
    })
        .then(res => res.data)
}

export async function createPrice(data, reverse = false) {
    return await axios({
        url: `${API}/settings/transfer/prices`,
        method: 'post',
        headers: {
            // 'Authorization' : 'Bearer ' + token,
            'Content-Type': 'application/json'
        },
        data: JSON.stringify({
            departure: reverse ? data.arrival : data.departure,
            arrival: reverse ? data.departure : data.arrival,
            currencyType: data.currency,
            pax1_3: data.pax1_3,
            pax4_6: data.pax4_6,
            pax7_10: data.pax7_10,
            duration: +data.duration
        })
    })
        .then(res => res.data)
}

export async function updatePrice(token, data) {
    return await axios({
        url: `${API}/settings/transfer/prices`,
        method: 'put',
        headers: {
            // 'Authorization' : 'Bearer ' + token,
            'Content-Type': 'application/json'
        },
        data: JSON.stringify(data)
    })
        .then(res => res.data)
}

export async function searchPrice(from, to) {
    return await axios({
        url: `${API}/settings/transfer/prices/search`,
        method: 'get',
        headers: {
            // 'Authorization' : 'Bearer ' + token,
            'Content-Type': 'application/json'
        },
        params: {
            from,
            to,
        }
    })
        .then(res => res.data)
}

export async function getPointsAll(token) {
    return await axios({
        url: `${API}/settings/transfer/points/all`,
        method: 'get',
        headers: {
            // 'Authorization' : 'Bearer ' + token
        }
    })
        .then(res => res.data)
}

export async function editSmtpSettings(token, data) {
    return await axios({
        url: `${API}/settings/smtp`,
        method: 'post',
        headers: {
            // 'Authorization' : 'Bearer ' + token,
            'Content-Type': 'application/json'
        },
        data: JSON.stringify({
            smtpServer: data.smtpServer,
            port: data.port,
            login: data.login,
            password: data.password,
        })
    })
        .then(res => res.data)
}

export async function getSmtpSettings(token) {
    return await axios({
        url: `${API}/settings/smtp`,
        method: 'get',
        headers: {
            // 'Authorization' : 'Bearer ' + token
        }
    })
        .then(res => res.data)
}

export async function getSeasonsAll(token) {
    return await axios({
        url: `${API}/settings/seasons/exchange/all`,
        method: 'get',
        headers: {
            // 'Authorization' : 'Bearer ' + token
        }
    })
        .then(res => res.data)
}

export async function getCurrency(token, id) {
    return await axios({
        url: `${API}/settings/exchange?seasonId=${id}`,
        method: 'get',
        headers: {
            // 'Authorization' : 'Bearer ' + token
        }
    })
        .then(res => res.data)
}

export async function addCurrency(token, id, rates) {
    return await axios({
        url: `${API}/settings/exchange`,
        method: 'post',
        headers: {
            // 'Authorization' : 'Bearer ' + token,
            'Content-Type': 'application/json'
        },
        data: JSON.stringify({
            seasonId: id,
            rates: rates.map(item => {
                return {
                    seasonId: id,
                    ...item
                }
            })
        })
    })
        .then(res => res.data)
}


export async function getAirstripsAll(token) {
    return await axios({
        url: `${API}/settings/geo/airstrips/all`,
        method: 'get',
        headers: {
            // 'Authorization' : 'Bearer ' + token
        }
    })
        .then(res => res.data)
}

export async function getAirstrip(token, id) {
    return await axios({
        url: `${API}/settings/geo/airstrips?id=${id}`,
        method: 'get',
        headers: {
            // 'Authorization' : 'Bearer ' + token
        }
    })
        .then(res => res.data)
}

export async function createAirstrip(token, data) {
    return await axios({
        url: `${API}/settings/geo/airstrips`,
        method: 'post',
        headers: {
            // 'Authorization' : 'Bearer ' + token,
            'Content-Type': 'application/json'
        },
        data: JSON.stringify({
            names: data.names,
            transferTerritorial: true,
            areaIds: data.areas,
            googlePlaceId: data.googlePlaceId,
        })
    })
        .then(res => res.data)
}

export async function updateAirstrip(token, data) {
    return await axios({
        url: `${API}/settings/geo/airstrips`,
        method: 'put',
        headers: {
            // 'Authorization' : 'Bearer ' + token,
            'Content-Type': 'application/json'
        },
        data: JSON.stringify({
            id: data.id,
            names: data.names,
            transferTerritorial: data.transferTerritorial,
            areaIds: data.areas,
            googlePlaceId: data.googlePlaceId,
        })
    })
        .then(res => res.data)
}

export async function deleteAirstrip(token, id) {
    return await axios({
        url: `${API}/settings/geo/airstrips?id=${id}`,
        method: 'delete',
        headers: {
            // 'Authorization' : 'Bearer ' + token
        }
    })
        .then(res => res.data)
}

export async function getCountries() {
    return await axios({
        url: `${API}/settings/geo/countries`,
        method: 'get'
    }).then(res => res.data)
}

export async function getTerritoriesAll(token) {
    return await axios({
        url: `${API}/settings/geo/territories/all`,
        method: 'get',
        headers: {
            // 'Authorization' : 'Bearer ' + token
        }
    })
        .then(res => res.data)
}

export async function getTerritory(token, id) {
    return await axios({
        url: `${API}/settings/geo/territories?id=${id}`,
        method: 'get',
        headers: {
            // 'Authorization' : 'Bearer ' + token
        }
    })
        .then(res => res.data)
}

export async function createTerritory(token, data) {
    return await axios({
        url: `${API}/settings/geo/territories`,
        method: 'post',
        headers: {
            // 'Authorization' : 'Bearer ' + token,
            'Content-Type': 'application/json'
        },
        data: JSON.stringify({
            names: data.names,
            type: data.type,
            countryId: data.countryId,
            googlePlaceId: data.googlePlaceId,
        })
    })
        .then(res => res.data)
}

export async function updateTerritory(token, data) {
    return await axios({
        url: `${API}/settings/geo/territories`,
        method: 'put',
        headers: {
            // 'Authorization' : 'Bearer ' + token,
            'Content-Type': 'application/json'
        },
        data: JSON.stringify(data)
    })
        .then(res => res.data)
}


export async function deleteTerritory(token, id) {
    return await axios({
        url: `${API}/settings/geo/territories?id=${id}`,
        method: 'delete',
        headers: {
            // 'Authorization' : 'Bearer ' + token
        }
    })
        .then(res => res.data)
}

export async function getAreasAll(token) {
    return await axios({
        url: `${API}/settings/geo/areas/all`,
        method: 'get',
        headers: {
            // 'Authorization' : 'Bearer ' + token
        }
    })
        .then(res => res.data)
}

export async function getArea(token, id) {
    return await axios({
        url: `${API}/settings/geo/areas?id=${id}`,
        method: 'get',
        headers: {
            // 'Authorization' : 'Bearer ' + token
        }
    })
        .then(res => res.data)
}

export async function getAreasLocaitonAll(token, id) {
    return await axios({
        url: `${API}/settings/geo/areas/titles?locationId=${id}`,
        method: 'get',
        headers: {
            // 'Authorization' : 'Bearer ' + token
        }
    })
        .then(res => res.data)
}

export async function createArea(token, data) {
    return await axios({
        url: `${API}/settings/geo/areas`,
        method: 'post',
        headers: {
            // 'Authorization' : 'Bearer ' + token,
            'Content-Type': 'application/json'
        },
        data: JSON.stringify({
            names: data.names,
            locationId: data.location,
            transferTerritorial: true,
            googlePlaceId: data.googlePlaceId,
        })
    })
        .then(res => res.data)
}

export async function updateArea(token, data) {
    return await axios({
        url: `${API}/settings/geo/areas`,
        method: 'put',
        headers: {
            // 'Authorization' : 'Bearer ' + token,
            'Content-Type': 'application/json'
        },
        data: JSON.stringify({
            names: data.names,
            locationId: data.location,
            id: data.id,
            googlePlaceId: data.googlePlaceId,
        })
    })
        .then(res => res.data)
}

export async function deleteArea(token, id) {
    return await axios({
        url: `${API}/settings/geo/areas?id=${id}`,
        method: 'delete',
        headers: {
            // 'Authorization' : 'Bearer ' + token
        }
    })
        .then(res => res.data)
}

export async function getLocationsAll(token) {
    return await axios({
        url: `${API}/settings/geo/locations/all`,
        method: 'get',
        headers: {
            // 'Authorization' : 'Bearer ' + token
        }
    })
        .then(res => res.data)
}

export async function getLocation(token, id) {
    return await axios({
        url: `${API}/settings/geo/locations?id=${id}`,
        method: 'get',
        headers: {
            // 'Authorization' : 'Bearer ' + token
        }
    })
        .then(res => res.data)
}

export async function getLocationsTerritoriesAll(token, id) {
    return await axios({
        url: `${API}/settings/geo/locations/titles?territoryId=${id}`,
        method: 'get',
        headers: {
            // 'Authorization' : 'Bearer ' + token
        }
    })
        .then(res => res.data)
}

export async function createLocation(token, data) {
    return await axios({
        url: `${API}/settings/geo/locations`,
        method: 'post',
        headers: {
            // 'Authorization' : 'Bearer ' + token,
            'Content-Type': 'application/json'
        },
        data: JSON.stringify({
            names: data.names,
            territoryId: data.territory,
            transferTerritorial: data.transfer,
            googlePlaceId: data.googlePlaceId,
        })
    })
        .then(res => res.data)
}

export async function updateLocation(token, data) {
    return await axios({
        url: `${API}/settings/geo/locations`,
        method: 'put',
        headers: {
            // 'Authorization' : 'Bearer ' + token,
            'Content-Type': 'application/json'
        },
        data: JSON.stringify({
            id: data.id,
            names: data.names,
            territoryId: data.territory,
            transferTerritorial: data.transfer,
            googlePlaceId: data.googlePlaceId,
        })
    })
        .then(res => res.data)
}

export async function deleteLocation(token, id) {
    return await axios({
        url: `${API}/settings/geo/locations?id=${id}`,
        method: 'delete',
        headers: {
            // 'Authorization' : 'Bearer ' + token
        }
    })
        .then(res => res.data)
}

export async function getSeasonsType(token, type) {
    return await axios({
        url: `${API}/settings/seasons/${type}/all`,
        method: 'get',
        headers: {
            // 'Authorization' : 'Bearer ' + token
        }
    })
        .then(res => res.data)
}

export async function getSafariDetails() {
    return await axios({
        url: `${API}/settings/safari/details`,
        method: 'get',
    })
        .then(res => res.data)
}

export async function updateSafariDetails(data) {
    return await axios({
        url: `${API}/settings/safari/details`,
        method: 'post',
        headers: {
            'Content-Type': 'application/json'
        },
        data: JSON.stringify(data)
    })
        .then(res => res.data)
}


export async function createSeasonsType(token, type, data) {
    return await axios({
        url: `${API}/settings/seasons/${type}`,
        method: 'post',
        headers: {
            // 'Authorization' : 'Bearer ' + token,
            'Content-Type': 'application/json'
        },
        data: JSON.stringify(data)
    })
        .then(res => res.data)
}

export async function updateSeasonsType(token, type, data) {
    return await axios({
        url: `${API}/settings/seasons/${type}`,
        method: 'put',
        headers: {
            // 'Authorization' : 'Bearer ' + token,
            'Content-Type': 'application/json'
        },
        data: JSON.stringify(data)
    })
        .then(res => res.data)
}

export async function deleteSeasonsType(token, type, id) {
    return await axios({
        url: `${API}/settings/seasons/${type}?id=${id}`,
        method: 'delete',
        headers: {
            // 'Authorization' : 'Bearer ' + token,
        },
    })
        .then(res => res.data)
}


export async function getCarsSeasons(token, id) {
    return await axios({
        url: `${API}/settings/safari/car-rentals?seasonId=${id}`,
        method: 'get',
        headers: {
            // 'Authorization' : 'Bearer ' + token
        }
    })
        .then(res => res.data)
}

export async function getExpensesSeasons(token, id) {
    return await axios({
        url: `${API}/settings/safari/other-expenses?seasonId=${id}`,
        method: 'get',
        headers: {
            // 'Authorization' : 'Bearer ' + token
        }
    })
        .then(res => res.data)
}

export async function saveExpensesSeasons(token, id, data) {
    return await axios({
        url: `${API}/settings/safari/other-expenses`,
        method: 'post',
        headers: {
            // 'Authorization' : 'Bearer ' + token,
            'Content-Type': 'application/json'
        },
        data: JSON.stringify({
            seasonId: id,
            settings: data.map(item => {
                if (item.added) {
                    return {
                        currencyType: item.currencyType,
                        perPerson: item.perPerson,
                        perSafariDay: item.perSafariDay,
                        perCar: item.perCar,
                        price: +item.price,
                        seasonId: item.seasonId,
                        name: item.name
                    }
                }
                return {
                    currencyType: item.currencyType,
                    id: item.id,
                    perPerson: item.perPerson,
                    perSafariDay: item.perSafariDay,
                    perCar: item.perCar,
                    price: +item.price,
                    seasonId: item.seasonId,
                    name: item.name
                }
            })
        })
    })
        .then(res => res.data)
}

export async function saveCarSeasons(token, id, data) {
    return await axios({
        url: `${API}/settings/safari/car-rentals`,
        method: 'post',
        headers: {
            // 'Authorization' : 'Bearer ' + token,
            'Content-Type': 'application/json'
        },
        data: JSON.stringify({
            seasonId: id,
            settings: data.map(item => {
                if (item.added) {
                    return {
                        currencyType: item.currencyType,
                        price: +item.price,
                        seasonId: item.seasonId,
                        name: item.name
                    }
                }
                return {
                    currencyType: item.currencyType,
                    id: item.id,
                    price: +item.price,
                    seasonId: item.seasonId,
                    name: item.name
                }
            })
        })
    })
        .then(res => res.data)
}

export async function copyCarsSeasons(token, idFrom, idTo) {
    return await axios({
        url: `${API}/settings/safari/car-rentals/copy?fromSeasonId=${idFrom}&toSeasonId=${idTo}`,
        method: 'get',
        headers: {
            // 'Authorization' : 'Bearer ' + token
        }
    })
        .then(res => res.data)
}

export async function copyExpensesSeasons(token, idFrom, idTo) {
    return await axios({
        url: `${API}/settings/safari/other-expenses/copy?fromSeasonId=${idFrom}&toSeasonId=${idTo}`,
        method: 'get',
        headers: {
            // 'Authorization' : 'Bearer ' + token
        }
    })
        .then(res => res.data)
}

export async function copyExchangeSeasons(token, idFrom, idTo) {
    return await axios({
        url: `${API}/settings/exchange/copy?fromSeasonId=${idFrom}&toSeasonId=${idTo}`,
        method: 'get',
        headers: {
            // 'Authorization' : 'Bearer ' + token
        }
    })
        .then(res => res.data)
}

export async function copyFlightSeasons(token, idFrom, idTo) {
    return await axios({
        url: `${API}/settings/flights/copy?fromSeasonId=${idFrom}&toSeasonId=${idTo}`,
        method: 'post',
        headers: {
            // 'Authorization' : 'Bearer ' + token
        }
    })
        .then(res => res.data)
}

export async function copyParkSeasons(idFromSeason, idToSeason, idFromPark, idToPark) {
    return await axios({
        url: `${API}/settings/safari/park-prices/copy?fromSeasonId=${idFromSeason}&toSeasonId=${idToSeason}&fromParkId=${idFromPark}&toParkId=${idToPark}`,
        method: 'get',
    })
        .then(res => res.data)
}


export async function getParks(token) {
    return await axios({
        url: `${API}/settings/safari/park/titles`,
        method: 'get',
        headers: {
            // 'Authorization' : 'Bearer ' + token
        }
    })
        .then(res => res.data)
}

export async function getPark(token, id) {
    return await axios({
        url: `${API}/settings/safari/park?id=${id}`,
        method: 'get',
        headers: {
            // 'Authorization' : 'Bearer ' + token
        }
    })
        .then(res => res.data)
}

export async function createPark(token, data) {
    return await axios({
        url: `${API}/settings/safari/park`,
        method: 'post',
        headers: {
            // 'Authorization' : 'Bearer ' + token,
            'Content-Type': 'application/json'
        },
        data: JSON.stringify(data)
    })
        .then(res => res.data)
}

export async function updatePark(token, data) {
    return await axios({
        url: `${API}/settings/safari/park`,
        method: 'put',
        headers: {
            // 'Authorization' : 'Bearer ' + token,
            'Content-Type': 'application/json'
        },
        data: JSON.stringify(data)
    })
        .then(res => res.data)
}

export async function createParkPrice(token, season, park, data) {
    return await axios({
        url: `${API}/settings/safari/park-prices`,
        method: 'post',
        headers: {
            // 'Authorization' : 'Bearer ' + token,
            'Content-Type': 'application/json'
        },
        data: JSON.stringify({
            seasonId: season,
            parkId: park,
            prices: data
        })
    })
        .then(res => res.data)
}

export async function getParkPrice(token, season, park) {
    return await axios({
        url: `${API}/settings/safari/park-prices?seasonId=${season}&parkId=${park}`,
        method: 'get',
        headers: {
            // 'Authorization' : 'Bearer ' + token
        }
    })
        .then(res => res.data)
}

export async function deletePark(token, id) {
    return await axios({
        url: `${API}/settings/safari/park?id=${id}`,
        method: 'delete',
        headers: {
            // 'Authorization' : 'Bearer ' + token
        }
    })
        .then(res => res.data)
}


export async function getAirlinesAll(token) {
    return await axios({
        url: `${API}/settings/flights/companies/all`,
        method: 'get',
        headers: {
            // 'Authorization' : 'Bearer ' + token
        }
    })
        .then(res => res.data)
}

export async function getIslandsAll(token) {
    return await axios({
        url: `${API}/settings/activities/island/titles`,
        method: 'get',
        headers: {
            // 'Authorization' : 'Bearer ' + token
        }
    })
        .then(res => res.data)
}

export async function deleteIsland(token, id) {
    return await axios({
        url: `${API}/settings/activities/island?id=${id}`,
        method: 'delete',
        headers: {
            // 'Authorization' : 'Bearer ' + token
        }
    })
        .then(res => res.data)
}

export async function getIsland(token, id) {
    return await axios({
        url: `${API}/settings/activities/island?id=${id}`,
        method: 'get',
        headers: {
            // 'Authorization' : 'Bearer ' + token
        }
    })
        .then(res => res.data)
}

export async function createIsland(token, data) {
    return await axios({
        url: `${API}/settings/activities/island`,
        method: 'post',
        headers: {
            // 'Authorization' : 'Bearer ' + token,
            'Content-Type': 'application/json'
        },
        data: JSON.stringify(data)
    })
        .then(res => res.data)
}

export async function updateIsland(token, data) {
    return await axios({
        url: `${API}/settings/activities/island`,
        method: 'put',
        headers: {
            // 'Authorization' : 'Bearer ' + token,
            'Content-Type': 'application/json'
        },
        data: JSON.stringify(data)
    })
        .then(res => res.data)
}

export async function getIslandPrice(token, season, island) {
    return await axios({
        url: `${API}/settings/activities/island/prices?seasonId=${season}&activityId=${island}`,
        method: 'get',
        headers: {
            // 'Authorization' : 'Bearer ' + token
        }
    })
        .then(res => res.data)
}

export async function getIslandPriceCopy(token, from, to, island) {
    return await axios({
        url: `${API}/settings/activities/island/prices/copy?fromSeasonId=${from}&toSeasonId=${to}&activityId=${island}`,
        method: 'get',
        headers: {
            // 'Authorization' : 'Bearer ' + token
        }
    })
        .then(res => res.data)
}

export async function createActivityPrice(token, season, activity, data, type = 'island') {
    return await axios({
        url: `${API}/settings/activities/${type}/prices`,
        method: 'post',
        headers: {
            // 'Authorization' : 'Bearer ' + token,
            'Content-Type': 'application/json'
        },
        data: JSON.stringify({
            activityId: activity,
            seasonId: season,
            prices: data
        })
    })
        .then(res => res.data)
}


export async function getTanzaniaAll(token) {
    return await axios({
        url: `${API}/settings/activities/mainland/titles`,
        method: 'get',
        headers: {
            // 'Authorization' : 'Bearer ' + token
        }
    })
        .then(res => res.data)
}

export async function deleteTanzania(token, id) {
    return await axios({
        url: `${API}/settings/activities/mainland?id=${id}`,
        method: 'delete',
        headers: {
            // 'Authorization' : 'Bearer ' + token
        }
    })
        .then(res => res.data)
}

export async function getTanzania(token, id) {
    return await axios({
        url: `${API}/settings/activities/mainland?id=${id}`,
        method: 'get',
        headers: {
            // 'Authorization' : 'Bearer ' + token
        }
    })
        .then(res => res.data)
}

export async function createTanzania(token, data) {
    return await axios({
        url: `${API}/settings/activities/mainland`,
        method: 'post',
        headers: {
            // 'Authorization' : 'Bearer ' + token,
            'Content-Type': 'application/json'
        },
        data: JSON.stringify(data)
    })
        .then(res => res.data)
}

export async function updateTanzania(token, data) {
    return await axios({
        url: `${API}/settings/activities/mainland`,
        method: 'put',
        headers: {
            // 'Authorization' : 'Bearer ' + token,
            'Content-Type': 'application/json'
        },
        data: JSON.stringify(data)
    })
        .then(res => res.data)
}

export async function getTanzaniaPrice(token, season, island) {
    return await axios({
        url: `${API}/settings/activities/mainland/prices?seasonId=${season}&activityId=${island}`,
        method: 'get',
        headers: {
            // 'Authorization' : 'Bearer ' + token
        }
    })
        .then(res => res.data)
}

export async function getTanzaniaPriceCopy(token, from, to, tanzania) {
    return await axios({
        url: `${API}/settings/activities/mainland/prices/copy?fromSeasonId=${from}&toSeasonId=${to}&activityId=${tanzania}`,
        method: 'get',
        headers: {
            // 'Authorization' : 'Bearer ' + token
        }
    })
        .then(res => res.data)
}


export async function getSafariAll(token) {
    return await axios({
        url: `${API}/settings/activities/safari/titles`,
        method: 'get',
        headers: {
            // 'Authorization' : 'Bearer ' + token
        }
    })
        .then(res => res.data)
}

export async function deleteSafari(token, id) {
    return await axios({
        url: `${API}/settings/activities/safari?id=${id}`,
        method: 'delete',
        headers: {
            // 'Authorization' : 'Bearer ' + token
        }
    })
        .then(res => res.data)
}

export async function getSafari(token, id) {
    return await axios({
        url: `${API}/settings/activities/safari?id=${id}`,
        method: 'get',
        headers: {
            // 'Authorization' : 'Bearer ' + token
        }
    })
        .then(res => res.data)
}

export async function createSafari(token, data) {
    return await axios({
        url: `${API}/settings/activities/safari`,
        method: 'post',
        headers: {
            // 'Authorization' : 'Bearer ' + token,
            'Content-Type': 'application/json'
        },
        data: JSON.stringify(data)
    })
        .then(res => res.data)
}

export async function updateSafari(token, data) {
    return await axios({
        url: `${API}/settings/activities/safari`,
        method: 'put',
        headers: {
            // 'Authorization' : 'Bearer ' + token,
            'Content-Type': 'application/json'
        },
        data: JSON.stringify(data)
    })
        .then(res => res.data)
}

export async function getSafariPrice(token, season, safari) {
    return await axios({
        url: `${API}/settings/activities/safari/prices?seasonId=${season}&activityId=${safari}`,
        method: 'get',
        headers: {
            // 'Authorization' : 'Bearer ' + token
        }
    })
        .then(res => res.data)
}

export async function getSafariPriceCopy(token, from, to, safari) {
    return await axios({
        url: `${API}/settings/activities/safari/prices/copy?fromSeasonId=${from}&toSeasonId=${to}&activityId=${safari}`,
        method: 'get',
        headers: {
            // 'Authorization' : 'Bearer ' + token
        }
    })
        .then(res => res.data)
}


export async function getCamps(token, id) {
    return await axios({
        url: `${API}/settings/climbing/camps?mountId=${id}`,
        method: 'get',
        headers: {
            // 'Authorization' : 'Bearer ' + token
        }
    })
        .then(res => res.data)
}

export async function updateCamps(token, data, id) {
    return await axios({
        url: `${API}/settings/climbing/camps?mountId=${id}`,
        method: 'post',
        headers: {
            // 'Authorization' : 'Bearer ' + token,
            'Content-Type': 'application/json'
        },
        data: JSON.stringify(data)
    })
        .then(res => res.data)
}


export async function getDistances(token, id) {
    return await axios({
        url: `${API}/settings/climbing/distances?mountId=${id}`,
        method: 'get',
        headers: {
            // 'Authorization' : 'Bearer ' + token
        }
    })
        .then(res => res.data)
}

export async function updateDistances(token, data, id) {
    return await axios({
        url: `${API}/settings/climbing/distances?mountId=${id}`,
        method: 'post',
        headers: {
            // 'Authorization' : 'Bearer ' + token,
            'Content-Type': 'application/json'
        },
        data: JSON.stringify(data)
    })
        .then(res => res.data)
}


export async function getTemperature(token, id) {
    return await axios({
        url: `${API}/settings/climbing/temperatures?mountId=${id}`,
        method: 'get',
        headers: {
            // 'Authorization' : 'Bearer ' + token
        }
    })
        .then(res => res.data)
}

export async function updateTemperature(token, data, id) {
    return await axios({
        url: `${API}/settings/climbing/temperatures`,
        method: 'post',
        headers: {
            // 'Authorization' : 'Bearer ' + token,
            'Content-Type': 'application/json'
        },
        data: JSON.stringify({mountId: id, data: data.data})
    })
        .then(res => res.data)
}

export async function getMoon(token, year) {
    return await axios({
        url: `${API}/settings/moon?year=${year}`,
        method: 'get',
        headers: {
            // 'Authorization' : 'Bearer ' + token
        }
    })
        .then(res => res.data)
}


export async function getRoutesAll(token) {
    return await axios({
        url: `${API}/settings/climbing/routes/titles`,
        method: 'get',
        headers: {
            // 'Authorization' : 'Bearer ' + token
        }
    })
        .then(res => res.data)
}

export async function getRoutesGroups(start, end) {
    return await axios({
        url: `${API}/settings/groups${start ? `?start=${start}&end=${end}` : ''}`,
        method: 'get',
    })
        .then(res => res.data)
}

export async function getRoute(token, id) {
    return await axios({
        url: `${API}/settings/climbing/routes?id=${id}`,
        method: 'get',
        headers: {
            // 'Authorization' : 'Bearer ' + token
        }
    })
        .then(res => res.data)
}

export async function deleteRoute(token, id) {
    return await axios({
        url: `${API}/settings/climbing/routes?id=${id}`,
        method: 'delete',
        headers: {
            // 'Authorization' : 'Bearer ' + token
        }
    })
        .then(res => res.data)
}

export async function createRoute(token, data) {
    return await axios({
        url: `${API}/settings/climbing/routes`,
        method: 'post',
        headers: {
            // 'Authorization' : 'Bearer ' + token,
            'Content-Type': 'application/json'
        },
        data: JSON.stringify(data)
    })
        .then(res => res.data)
}

export async function updateRoute(token, data) {
    return await axios({
        url: `${API}/settings/climbing/routes`,
        method: 'put',
        headers: {
            // 'Authorization' : 'Bearer ' + token,
            'Content-Type': 'application/json'
        },
        data: JSON.stringify(data)
    })
        .then(res => res.data)
}

export async function getAdvices() {
    return await axios({
        url: `${API}/settings/advices/all`,
        method: 'get',
    })
        .then(res => res.data)
}

export async function getAdvicesRecommended(start) {
    return await axios({
        url: `${API}/settings/advices/find?startDate=${start}`,
        method: 'get',
    })
        .then(res => res.data)
}

export async function updateAdvice(token, data) {
    return await axios({
        url: `${API}/settings/advices`,
        method: 'post',
        headers: {
            // 'Authorization' : 'Bearer ' + token,
            'Content-Type': 'application/json'
        },
        data: JSON.stringify(data)
    })
        .then(res => res.data)
}

export async function copyAdvice(token, yearFrom, yearTo) {
    return await axios({
        url: `${API}/settings/advices/copy?fromYear=${yearFrom}&toYear=${yearTo}`,
        method: 'get',
        headers: {
            // 'Authorization' : 'Bearer ' + token,
        },
    })
        .then(res => res.data)
}

export async function getLimits(token) {
    return await axios({
        url: `${API}/settings/limits`,
        method: 'get',
        headers: {
            // 'Authorization' : 'Bearer ' + token
        }
    })
        .then(res => res.data)
}

export async function updateLimits(token, data) {
    return await axios({
        url: `${API}/settings/limits`,
        method: 'post',
        headers: {
            // 'Authorization' : 'Bearer ' + token,
            'Content-Type': 'application/json'
        },
        data: JSON.stringify(data)
    })
        .then(res => res.data)
}

export async function getMountains(token) {
    return await axios({
        url: `${API}/settings/geo/mountains/all`,
        method: 'get',
        headers: {
            // 'Authorization' : 'Bearer ' + token
        }
    })
        .then(res => res.data)
}

export async function updateMountain(token, data) {
    return await axios({
        url: `${API}/settings/geo/mountains`,
        method: 'put',
        headers: {
            // 'Authorization' : 'Bearer ' + token,
            'Content-Type': 'application/json'
        },
        data: JSON.stringify(data)
    })
        .then(res => res.data)
}

export async function createMountain(token, data) {
    return await axios({
        url: `${API}/settings/geo/mountains`,
        method: 'post',
        headers: {
            // 'Authorization' : 'Bearer ' + token,
            'Content-Type': 'application/json'
        },
        data: JSON.stringify(data)
    })
        .then(res => res.data)
}

export async function deleteMountain(token, id) {
    return await axios({
        url: `${API}/settings/geo/mountains?id=${id}`,
        method: 'delete',
        headers: {
            // 'Authorization' : 'Bearer ' + token,
        },
    })
        .then(res => res.data)
}


export async function getAdditionals(token) {
    return await axios({
        url: `${API}/settings/climbing/additional-options/titles`,
        method: 'get',
        headers: {
            // 'Authorization' : 'Bearer ' + token
        }
    })
        .then(res => res.data)
}

export async function createAdditional(token, data) {
    return await axios({
        url: `${API}/settings/climbing/additional-options`,
        method: 'post',
        headers: {
            // 'Authorization' : 'Bearer ' + token,
            'Content-Type': 'application/json'
        },
        data: JSON.stringify(data)
    })
        .then(res => res.data)
}

export async function updateAdditional(token, data) {
    return await axios({
        url: `${API}/settings/climbing/additional-options`,
        method: 'put',
        headers: {
            // 'Authorization' : 'Bearer ' + token,
            'Content-Type': 'application/json'
        },
        data: JSON.stringify(data)
    })
        .then(res => res.data)
}

export async function deleteAdditional(token, id) {
    return await axios({
        url: `${API}/settings/climbing/additional-options?id=${id}`,
        method: 'delete',
        headers: {
            // 'Authorization' : 'Bearer ' + token
        }
    })
        .then(res => res.data)
}

export async function getClimbingCosts(token, year, includeHotelsAndTransfers) {
    return await axios({
        url: `${API}/settings/climbing/costs?year=${year}&includeHotelsAndTransfers=${includeHotelsAndTransfers}`,
        method: 'get',
        headers: {
            // 'Authorization' : 'Bearer ' + token
        }
    })
        .then(res => res.data)
}

export async function getClimbingCostsV2(year, includeHotelsAndTransfers, include2026Taxes, type, residence, age, operatorId) {
    return await axios({
        url: `${API}/settings/climbing/routes/costs?year=${year}&type=${type}&residence=${residence}&age=${age}&includeHotelsAndTransfers=${includeHotelsAndTransfers}&include2026Taxes=${include2026Taxes}&operatorId=${operatorId}`,
        method: 'get',
        headers: {
        }
    })
        .then(res => res.data)
}

export async function getBaseClimbingCostsV2(year, includeHotelsAndTransfers, include2026Taxes, type, residence, age) {
    return await axios({
        url: `${API}/settings/climbing/routes/costs/base?year=${year}&type=${type}&residence=${residence}&age=${age}&includeHotelsAndTransfers=${includeHotelsAndTransfers}&include2026Taxes=${include2026Taxes}`,
        method: 'get',
        headers: {
        }
    })
        .then(res => res.data)
}

export async function updateClimbingCosts(token, includeHotelsAndTransfers, data, year) {
    return await axios({
        url: `${API}/settings/climbing/costs?year=${year}&includeHotelsAndTransfers=${includeHotelsAndTransfers}`,
        method: 'post',
        headers: {
            // 'Authorization' : 'Bearer ' + token,
            'Content-Type': 'application/json'
        },
        data: JSON.stringify(data)
    })
        .then(res => res.data)
}

export async function updateClimbingCostsV2(data) {
    return await axios({
        url: `${API}/settings/climbing/routes/costs`,
        method: 'post',
        headers: {
            'Content-Type': 'application/json'
        },
        data: JSON.stringify(data)
    })
        .then(res => res.data)
}

export async function updateBaseClimbingCostsV2(data) {
    return await axios({
        url: `${API}/settings/climbing/routes/costs/base`,
        method: 'post',
        headers: {
            'Content-Type': 'application/json'
        },
        data: JSON.stringify(data)
    })
        .then(res => res.data)
}

export function getClimbingTourLeader(year, includeHotelsAndTransfers, include2026Taxes, operatorId) {
    return axios.get(`${API}/settings/climbing/tour-leader/costs?year=${year}&includeHotelsAndTransfers=${includeHotelsAndTransfers}&include2026Taxes=${include2026Taxes}&operatorId=${operatorId}`)
}

export function updateClimbingTourLeader(includeHotelsAndTransfers, include2026Taxes, data, year, operatorId) {
    return axios.post(`${API}/settings/climbing/tour-leader/costs?year=${year}&includeHotelsAndTransfers=${includeHotelsAndTransfers}&include2026Taxes=${include2026Taxes}&operatorId=${operatorId}`, data)
}

export async function getClimbingDetails(token, type) {
    return await axios({
        url: `${API}/settings/climbing/details?type=${type}`,
        method: 'get',
        headers: {
            // 'Authorization' : 'Bearer ' + token
        }
    })
        .then(res => res.data)
}

export async function getClimbingRouteDetails(operatorId, routeId, type, includeHotelsAndTransfers) {
    return await axios({
        url: `${API}/settings/climbing/route-details/details?operatorId=${operatorId}&routeId=${routeId}&type=${type}&includeHotelsAndTransfers=${includeHotelsAndTransfers}`,
        method: 'get',
    })
        .then(res => res.data)
}

export async function updateClimbingDetails(token, data) {
    return await axios({
        url: `${API}/settings/climbing/details`,
        method: 'post',
        headers: {
            // 'Authorization' : 'Bearer ' + token,
            'Content-Type': 'application/json'
        },
        data: JSON.stringify(data)
    })
        .then(res => res.data)
}

export async function createClimbingRouteDetails(data) {
    return await axios({
        url: `${API}/settings/climbing/route-details`,
        method: 'post',
        headers: {
            'Content-Type': 'application/json'
        },
        data: JSON.stringify(data)
    })
        .then(res => res.data)
}

export async function updateClimbingRouteDetails(id, data) {
    return await axios({
        url: `${API}/settings/climbing/route-details/${id}`,
        method: 'put',
        headers: {
            'Content-Type': 'application/json'
        },
        data: JSON.stringify(data)
    })
        .then(res => res.data)
}

export async function copyClimbingRouteById(data) {
    return await axios({
        url: `${API}/settings/climbing/route-details/copy-route`,
        method: 'post',
        headers: {
            'Content-Type': 'application/json'
        },
        data: JSON.stringify(data)
    })
        .then(res => res.data)
}
export async function copyClimbingOperatorById(data) {
    return await axios({
        url: `${API}/settings/climbing/route-details/copy-operator`,
        method: 'post',
        headers: {
            'Content-Type': 'application/json'
        },
        data: JSON.stringify(data)
    })
        .then(res => res.data)
}

export async function getClimbingDiscounts(token) {
    return await axios({
        url: `${API}/settings/climbing/discounts`,
        method: 'get',
        headers: {
            // 'Authorization' : 'Bearer ' + token
        }
    })
        .then(res => res.data)
}

export async function updateClimbingDiscounts(token, data) {
    return await axios({
        url: `${API}/settings/climbing/discounts`,
        method: 'post',
        headers: {
            // 'Authorization' : 'Bearer ' + token,
            'Content-Type': 'application/json'
        },
        data: JSON.stringify(data)
    })
        .then(res => res.data)
}

export async function getTemplates(token, id) {
    return await axios({
        url: `${API}/settings/programs/templates/titles?userId=${id}`,
        method: 'get',
        headers: {
            // 'Authorization' : 'Bearer ' + token
        }
    })
        .then(res => res.data)
}

export async function getTemplate(id) {
    return await axios({
        url: `${API}/settings/programs/templates?id=${id}`,
        method: 'get',
    })
        .then(res => res.data)
}

export async function createTemplate(data) {
    return await axios({
        url: `${API}/settings/programs/templates`,
        method: 'post',
        headers: {
            'Content-Type': 'application/json'
        },
        data: JSON.stringify(data)
    })
        .then(res => res.data)
}

export async function updateTemplate(data) {
    return await axios({
        url: `${API}/settings/programs/templates`,
        method: 'put',
        headers: {
            'Content-Type': 'application/json'
        },
        data: JSON.stringify(data)
    })
        .then(res => res.data)
}

export async function deleteTemplate(token, id) {
    return await axios({
        url: `${API}/settings/programs/templates?id=${id}`,
        method: 'delete',
        headers: {
            // 'Authorization' : 'Bearer ' + token
        }
    })
        .then(res => res.data)
}

export async function shareTemplate(token, id, userId, users) {
    return await axios({
        url: `${API}/settings/programs/templates/share`,
        method: 'post',
        headers: {
            // 'Authorization' : 'Bearer ' + token,
            'Content-Type': 'application/json'
        },
        data: JSON.stringify({
            id,
            userId,
            shareUserIds: users
        })
    })
        .then(res => res.data)
}

export async function copyTemplate(token, id, userId) {
    return await axios({
        url: `${API}/settings/programs/templates/copy?fromId=${id}&userId=${userId}`,
        method: 'post',
        headers: {
            // 'Authorization' : 'Bearer ' + token,
        },
    })
        .then(res => res.data)
}

export async function calcTemplatePrice(data, clientId, recalculate) {
    return await axios({
        url: `${API}/settings/programs/calculate?clientId=${clientId}&recalculate=${recalculate}`,
        method: 'post',
        headers: {
            'content-type': 'application/json'
        },
        data: JSON.stringify(data)
    })
        .then(res => res.data)
}

export async function getClientsAll(id) {
    return await axios({
        url: `${API}/settings/clients/titles?userId=${id}`,
        method: 'get',
    })
        .then(res => res.data)
}

export async function getClientRecoveries(id) {
    return await axios({
        url: `${API}/settings/clients/histories/titles?clientId=${id}`,
        method: 'get',
    })
        .then(res => res.data)
}

export async function getClientRecover(id) {
    return await axios({
        url: `${API}/settings/clients/histories?id=${id}`,
        method: 'get',
    })
        .then(res => res.data)
}

export async function getClientLink(id) {
    return await axios({
        url: `${API}/settings/clients/link?id=${id}`,
        method: 'get',
    })
        .then(res => res.data)
}


export async function createClients(data) {
    return await axios({
        url: `${API}/settings/clients`,
        method: 'post',
        headers: {
            'content-type': 'application/json'
        },
        data: JSON.stringify(data)
    })
        .then(res => res.data)
}

export async function updateClients(data) {
    return await axios({
        url: `${API}/settings/clients`,
        method: 'put',
        headers: {
            'content-type': 'application/json'
        },
        data: JSON.stringify(data)
    })
        .then(res => res.data)
}

export async function updateLastContactClient(id, date) {
    return await axios({
        url: `${API}/settings/clients/contact?id=${id}&date=${date}`,
        method: 'put',
        headers: {
            'content-type': 'application/json'
        },
    })
        .then(res => res.data)
}

export async function updateStatusClient(id, status) {
    return await axios({
        url: `${API}/settings/clients/status?id=${id}&status=${status}`,
        method: 'put',
        headers: {
            'content-type': 'application/json'
        },
    })
        .then(res => res.data)
}


export async function shareClient(id, userId, users) {
    return await axios({
        url: `${API}/settings/clients/share`,
        method: 'post',
        headers: {
            'content-type': 'application/json'
        },
        data: JSON.stringify({
            id,
            userId,
            shareUserIds: users
        })
    })
        .then(res => res.data)
}

export async function copyClient(id, userId) {
    return await axios({
        url: `${API}/settings/clients/copy?fromId=${id}&userId=${userId}`,
        method: 'post',
    })
        .then(res => res.data)
}

export async function getClient(id) {
    return await axios({
        url: `${API}/settings/clients?id=${id}`,
        method: 'get',
    })
        .then(res => res.data)
}

export async function deleteClient(id, userId) {
    return await axios({
        url: `${API}/settings/clients?id=${id}&userId=${userId}`,
        method: 'delete',
    })
        .then(res => res.data)
}

export async function getHotelsAll(filter) {
    return await axios({
        url: `${HOTELS}/names/all${filter ? '?filter=' + filter : ''}`,
        method: 'get',
    })
        .then(res => res.data)
}

export async function getHotelsMeals(id) {
    return await axios({
        url: `${HOTELS}?id=${id}`,
        method: 'get',
    })
        .then(res => res.data)
}

export async function getHotelsRoom(id) {
    return await axios({
        url: `${HOTELS}/rooms?hotelId=${id}`,
        method: 'get',
    })
        .then(res => res.data)
}

export async function getRoomAccommodations(id) {
    return await axios({
        url: `${API}/hotels/accommodations?roomId=${id}`,
        method: 'get',
    })
        .then(res => res.data)
}

export async function getHotelPrice(data) {
    return await axios({
        url: `${HOTELS}/room-prices/price?searchDate=${data.date}&hotelId=${data.hotelId}&accommodationType=${data.accommodationType}&mealType=${data.mealType}&roomId=${data.roomId}`,
        method: 'get',
    })
        .then(res => res.data)
}

export async function updateHotelPrice(data) {
    return await axios({
        url: `${HOTELS}/room-prices/price`,
        method: 'put',
        data
    })
        .then(res => res.data)
}

export async function getAlternativeHotels(data) {
    return await axios({
        url: `${HOTELS}/room-prices/alternatives`,
        method: 'post',
        headers: {
            'content-type': 'application/json'
        },
        data: JSON.stringify(data)
    })
        .then(res => res.data)
}

export async function getHotelsTitles() {
    return await axios({
        url: `${API}/settings/hotels/titles`,
        method: 'get',
    })
        .then(res => res.data)
}

export async function getHotel(id) {
    return await axios({
        url: `${API}/settings/hotels?id=${id}`,
        method: 'get',
    })
        .then(res => res.data)
}

export async function createHotel(data) {
    return await axios({
        url: `${API}/settings/hotels`,
        method: 'post',
        headers: {
            'content-type': 'application/json'
        },
        data: JSON.stringify(data)
    })
        .then(res => res.data)
}

export async function updateHotel(data) {
    return await axios({
        url: `${API}/settings/hotels`,
        method: 'put',
        headers: {
            'content-type': 'application/json'
        },
        data: JSON.stringify(data)
    })
        .then(res => res.data)
}


export async function deleteHotel(id) {
    return await axios({
        url: `${API}/settings/hotels?id=${id}`,
        method: 'delete',
    })
        .then(res => res.data)
}

export async function getItinerary(link) {
    return await axios({
        url: `${API}/settings/clients/descriptions/${link}`,
        method: 'get',
    })
        .then(res => res.data)
}


export async function getTexts() {
    return await axios({
        url: `${API}/settings/texts`,
        method: 'get',
    })
        .then(res => res.data)
}

export async function getTextsTerrDescriptions() {
    return await axios({
        url: `${API}/settings/texts/location-descriptions`,
        method: 'get',
    })
        .then(res => res.data)
}

export async function updateTexts(data) {
    return await axios({
        url: `${API}/settings/texts`,
        method: 'post',
        headers: {
            'Content-Type': 'application/json'
        },
        data: JSON.stringify(data)
    })
        .then(res => res.data)
}

export async function updateTextsTerrDescriptions(data) {
    return await axios({
        url: `${API}/settings/texts/location-descriptions`,
        method: 'post',
        headers: {
            'Content-Type': 'application/json'
        },
        data: JSON.stringify(data)
    })
        .then(res => res.data)
}


// hotels
const HOTELS = `${process.env.VUE_APP_ORIGIN === 'true' ? 'https://api.altezza.travel' : 'https://dev-api.altezza.travel'}/hotels-db`

export async function getHotelsAdvanced() {
    return await axios({
        url: `${HOTELS}/titles`,
        method: 'get',
    })
        .then(res => res.data)
}

export async function getAmenities() {
    return await axios({
        url: `${HOTELS}/amenities`,
        method: 'get',
    })
        .then(res => res.data)
}

export async function getHotelAdvanced(id) {
    return await axios({
        url: `${HOTELS}?id=${id}`,
        method: 'get',
    })
        .then(res => res.data)
}

export async function getHotelsChains() {
    return await axios({
        url: `${HOTELS}/chains/all`,
        method: 'get',
    })
        .then(res => res.data)
}

export async function createHotelAdvanced(data) {
    return await axios({
        url: `${HOTELS}`,
        method: 'post',
        headers: {
            'Content-Type': 'application/json'
        },
        data: JSON.stringify(data)
    })
        .then(res => res.data)
}

export async function updateHotelAdvanced(data) {
    return await axios({
        url: `${HOTELS}`,
        method: 'put',
        headers: {
            'Content-Type': 'application/json'
        },
        data: JSON.stringify(data)
    })
        .then(res => res.data)
}

export async function getHotelsPaymentPolicy(id) {
    return await axios({
        url: `${HOTELS}/${id}/payment-policy`,
        method: 'get',
    })
        .then(res => res.data)
}

export async function updateHotelsPaymentPolicy(data, id) {
    return await axios({
        url: `${HOTELS}/${id}/payment-policy`,
        method: 'put',
        headers: {
            'Content-Type': 'application/json'
        },
        data: JSON.stringify(data)
    })
        .then(res => res.data)
}

export async function getHotelsNights(id) {
    return await axios({
        url: `${HOTELS}/min-nights-stay-season?hotelId=${id}`,
        method: 'get',
    })
        .then(res => res.data)
}

export async function updateHotelsNights(data, id) {
    return await axios({
        url: `${HOTELS}/min-nights-stay-season?hotelId=${id}`,
        method: 'post',
        headers: {
            'Content-Type': 'application/json'
        },
        data: JSON.stringify(data)
    })
        .then(res => res.data)
}

export async function getHotelsDuring(id) {
    return await axios({
        url: `${HOTELS}/closed-during-seasons?hotelId=${id}`,
        method: 'get',
    })
        .then(res => res.data)
}

export async function updateHotelsDuring(data, id) {
    return await axios({
        url: `${HOTELS}/closed-during-seasons?hotelId=${id}`,
        method: 'post',
        headers: {
            'Content-Type': 'application/json'
        },
        data: JSON.stringify(data)
    })
        .then(res => res.data)
}

export async function getHotelsCamps(id) {
    return await axios({
        url: `${HOTELS}/mobile-camps?hotelId=${id}`,
        method: 'get',
    })
        .then(res => res.data)
}

export async function updateHotelsCamps(data, id) {
    return await axios({
        url: `${HOTELS}/mobile-camps?hotelId=${id}`,
        method: 'post',
        headers: {
            'Content-Type': 'application/json'
        },
        data: JSON.stringify(data)
    })
        .then(res => res.data)
}

export async function getHotelsRooms(id) {
    return await axios({
        url: `${HOTELS}/rooms?hotelId=${id}`,
        method: 'get',
    })
        .then(res => res.data)
}
export async function getHotelsRoomsV2(id) {
    return await axios({
        url: `${HOTELS}/${id}/rooms?`,
        method: 'get',
    })
        .then(res => res.data)
}

export async function updateHotelsRooms(data, id) {
    return await axios({
        url: `${HOTELS}/rooms?hotelId=${id}`,
        method: 'post',
        headers: {
            'Content-Type': 'application/json'
        },
        data: JSON.stringify(data)
    })
        .then(res => res.data)
}

export async function updateHotelsRoomsV2(data, id) {
    return await axios({
        url: `${HOTELS}/${id}/rooms`,
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json'
        },
        data: JSON.stringify(data)
    })
        .then(res => res.data)
}

export async function getHotelsHistory(id) {
    return await axios({
        url: `${HOTELS}/histories?hotelId=${id}`,
        method: 'get',
    })
        .then(res => res.data)
}


export async function getHotelsSeasons(id) {
    return await axios({
        url: `${HOTELS}/seasons/all?hotelId=${id}`,
        method: 'get',
    })
        .then(res => res.data)
}

export async function updateHotelsSeasons(data, id) {
    return await axios({
        url: `${HOTELS}/seasons?hotelId=${id}`,
        method: 'post',
        headers: {
            'Content-Type': 'application/json'
        },
        data: JSON.stringify(data)
    })
        .then(res => res.data)
}

export async function getHotelsPeriods(id) {
    return await axios({
        url: `${HOTELS}/periods/all?hotelId=${id}`,
        method: 'get',
    })
        .then(res => res.data)
}

export async function updateHotelsPeriods(data, id) {
    return await axios({
        url: `${HOTELS}/periods?hotelId=${id}`,
        method: 'post',
        headers: {
            'Content-Type': 'application/json'
        },
        data: JSON.stringify(data)
    })
        .then(res => res.data)
}

export async function getHotelsOffers(id, year) {
    return await axios({
        url: `${HOTELS}/special-offers?hotelId=${id}&year=${year}`,
        method: 'get',
    })
        .then(res => res.data)
}

export async function updateHotelsOffers(data) {
    return await axios({
        url: `${HOTELS}/special-offers`,
        method: 'post',
        headers: {
            'Content-Type': 'application/json'
        },
        data: JSON.stringify(data)
    })
        .then(res => res.data)
}

export async function getHotelsDriverAccommodations(id) {
  return await axios({
    url: `${HOTELS}/${id}/driver-accommodations`,
    method: 'get',
  })
    .then(res => res.data)
}

export async function getHotelsSafetyMeasurements(id) {
  return await axios({
    url: `${HOTELS}/${id}/safety-measurements`,
    method: 'get',
  })
    .then(res => res.data)
}

export function getSafariDurationDiscounts(year) {
  return axios.get(`${API}/settings/safari/duration-discounts?year=${year}`)
}

export async function getHotelsAditionalPrices(id, year) {
    return await axios({
        url: `${HOTELS}/additional-prices?hotelId=${id}&year=${year}`,
        method: 'get',
    })
        .then(res => res.data)
}

export async function updateHotelsAditionalPrices(data, id, year) {
    return await axios({
        url: `${HOTELS}/additional-prices?hotelId=${id}&year=${year}`,
        method: 'post',
        headers: {
            'Content-Type': 'application/json'
        },
        data: JSON.stringify(data)
    })
        .then(res => res.data)
}

export async function copyHotelsAditionalPrices(id, yearFrom, yearTo) {
    return await axios({
        url: `${HOTELS}/additional-prices/copy?hotelId=${id}&yearFrom=${yearFrom}&yearTo=${yearTo}`,
        method: 'get',
    })
        .then(res => res.data)
}

export async function getHotelsRoomPrices(id, year) {
    return await axios({
        url: `${HOTELS}/room-prices?hotelId=${id}&year=${year}`,
        method: 'get',
    })
        .then(res => res.data)
}

export async function getHotelsRoomPricesResults(id, year) {
    return await axios({
        url: `${HOTELS}/room-prices/results?hotelId=${id}&year=${year}`,
        method: 'get',
    })
        .then(res => res.data)
}

export async function updateHotelsRoomPricesResults(data) {
    return await axios({
        url: `${HOTELS}/room-prices/results`,
        method: 'post',
        headers: {
            'Content-Type': 'application/json'
        },
        data: JSON.stringify(data)
    })
        .then(res => res.data)
}


export async function updateHotelsRoomPrices(data, id, year) {
    return await axios({
        url: `${HOTELS}/room-prices?hotelId=${id}&year=${year}`,
        method: 'post',
        headers: {
            'Content-Type': 'application/json'
        },
        data: JSON.stringify(data)
    })
        .then(res => res.data)
}

export async function calculateHotelsRoomPrices(data) {
    return await axios({
        url: `${HOTELS}/room-prices/calculate`,
        method: 'post',
        headers: {
            'Content-Type': 'application/json'
        },
        data: JSON.stringify(data)
    })
        .then(res => res.data)
}

export async function getPartners() {
    return await axios({
        url: `${process.env.VUE_APP_ORIGIN === 'true' ? 'https://api.altezza.travel' : 'https://dev-api.altezza.travel'}/companions/api/v1/partners/titles`,
        method: 'get',
    })
        .then(res => res.data)
}


export function getHotelMinNightStay(hotelId) {
    return axios.get(`${HOTELS}/min-nights-stay-season?hotelId=${hotelId}`)
}

export function getHotelClosedDay(hotelId) {
    return axios.get(`${HOTELS}/closed-during-seasons?hotelId=${hotelId}`)
}

export function getAirportVipServices(year) {
    return axios.get(`${API}/settings/airport-vip-services?year=${year}`)
}

export function getPlanes() {
    return axios.get(`${API}/settings/planes`)
}

export async function updatePlanes(data) {
    return await axios({
        url: `${API}/settings/planes`,
        method: 'put',
        headers: {
            'content-type': 'application/json'
        },
        data: JSON.stringify(data)
    })
        .then(res => res.data)
}

export function getAllAirCompanies() {
    return axios.get(`${API}/settings/companies/all`)
}

export function postAirportVipServices(year, data) {
    return axios.post(`${API}/settings/airport-vip-services?year=${year}`, data)
}

export function copyAirportVipServices(fromYear, toYear) {
    return axios.get(`${API}/settings/airport-vip-services/copy?fromYear=${fromYear}&toYear=${toYear}`)
}

export function postSpecialOffers(data, hotelId, year) {
    return axios.post(`${HOTELS}/special-offers?hotelId=${hotelId}&year=${year}`, data)
}

export function putDriverAccommodations(data, hotelId) {
    return axios.put(`${HOTELS}/${hotelId}/driver-accommodations`, data)
}

export function putSafetyMeasurements(data, hotelId) {
    return axios.put(`${HOTELS}/${hotelId}/safety-measurements`, data)
}

export function putSafariDurationDiscounts(data) {
    return axios.put(`${API}/settings/safari/duration-discounts`, data)
}

export function copySpecialOffers(hotelId, yearFrom, yearTo) {
    return axios.get(`${HOTELS}/special-offers/copy?hotelId=${hotelId}&yearFrom=${yearFrom}&yearTo=${yearTo}`)
}

export function postTransferClient(payload) {
    return axios.post(`${API}/settings/clients/transfer?id=${payload.id}&userId=${payload.userId}&transferUserId=${payload.transferUserId}`)
}

export function postConfigureMfa(userId, isEnable) {
    return axios.post(`${API}/users/${userId}/mfa`, {"enable": isEnable})
}

export async function upgradeToSingleRoom(data) {
    return await axios({
        url: `${API}/settings/payments/hotels/upgrade-to-single-room`,
        method: "POST",
        data: data
    }).then(res => res.data)
}

export async function uploadFile(formData) {
    return await axios({
        url: `${API}/files`,
        method: "POST",
        headers: {
          "Content-Type": "multipart/form-data",
        },
        data: formData
    }).then(res => res.data)
}
